<template>
  <IQOS required :title="$t('settings.language.title')" :readonly="editing">
    <p class="comment  pt-0 c-grey">{{ $t("settings.language.choose") }}</p>
    <BlackSelect class="iqos-group-item" :readonly="!editing" v-model="lang">
      <option value="ua">Українська</option>
      <option value="ru">Русский</option>
      <option value="en">English</option>
    </BlackSelect>

    <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @cancel="hideEditUI"
      @accept="onEditFinish"
    />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import BlackSelect from "@/components/BlackSelect.vue";

import IQOSActions from "@/components/IQOSActions.vue";

import AuthAPI from "@/api/auth";

export default {
  data() {
    return {
      lang: null,
      editing: false,
    };
  },
  methods: {
    changeLanguage() {
      AuthAPI.setLanguage(this.lang)
        .then((ok) => {
          //Show success message (not needed probably)
        })
        .catch((error) => {
          //Show error happened (not possible lol)
        });
    },
    reset() {
      this.lang = this.$store.state.owner.language;
    },
    onEditFinish() {
      this.changeLanguage();
      this.editing = false;
    },
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
  },
  mounted() {
    this.reset();
  },
  components: {
    IQOS,
    BlackSelect,
    IQOSActions,
  },
};
</script>

<style scoped></style>
